/**
 * Workflows breadcrumb origins. Built on the generic `from`-origin helpers in
 * `breadcrumbOrigin.ts`; this module only owns the Workflows-specific matcher table.
 *
 * The Launch Workflow wizard is reached from the Company Workflows page, which carries
 * the originating URL in the `from` query param so the root crumb can return the user to
 * the exact (filtered) list. Falls back to Company Workflows when `from` is absent.
 */
import { type OriginMatcher, createOriginParser } from "./breadcrumbOrigin";

export { appendCurrentLocationAsFrom } from "./breadcrumbOrigin";

const ORIGIN_MATCHERS: OriginMatcher[] = [{ match: "/company/workflows", label: "Company Workflows" }];

export const WORKFLOWS_DEFAULT_ORIGIN = { href: "/company/workflows", label: "Company Workflows" } as const;

export type WorkflowsOrigin = {
	/** Internal href the root crumb links back to. */
	from: string;
	/** Display label for the originating page. */
	label: string;
};

export const parseWorkflowsOrigin = createOriginParser(ORIGIN_MATCHERS, WORKFLOWS_DEFAULT_ORIGIN);
